import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from '@nuxtjs/composition-api';
import ThemeProvider from '~/components/ThemeProvider.vue';
import { useSanityDocument } from '~/composables/useSanityDocument';
import { useStore } from '~/store/composable';
import { EExchangeState } from '~/store/customReveal/types';
import { ThemeName } from '~/store/types';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import PromoBoxExchange from './PromoBoxExchange.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoBoxDialog',
  setup(__props) {

const { state } = useStore();
const route = useRoute();
const router = useRouter();
const shouldShowDialog = ref(false);
const currentExchangeState = computed(
  () => state?.customReveal?.currentExchangeState,
);

const { doc, isLoading } = useSanityDocument<
  ISanityDocuments[SanityDocumentSchema.PROMO_BOX]
>(
  computed(() => ({
    slug: route.value?.query?.promo?.toString() ?? '',
    _type: SanityDocumentSchema.PROMO_BOX,
  })),
);

const handleClose = () => {
  shouldShowDialog.value = false;
  router.push({
    query: {
      ...route.value.query,
      promo: undefined,
    },
  });
};

watch(
  () => route.value.query?.promo,
  (current, previous) => {
    if (current && !shouldShowDialog.value) {
      shouldShowDialog.value = true;
    }
    if (!current && shouldShowDialog.value) {
      shouldShowDialog.value = false;
    }
  },
  { immediate: true },
);

return { __sfc: true,state, route, router, shouldShowDialog, currentExchangeState, doc, isLoading, handleClose, ThemeProvider, EExchangeState, ThemeName, PromoBoxExchange }
}

})